import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpParams } from "@angular/common/http";
import { lastValueFrom } from "rxjs";
import { FileUploadComponent } from "src/app/shared/components/file-upload/file-upload.component";
import { AuthService } from "src/app/core/services/AuthService";
import { CertificadoService } from "src/app/core/services/certificado.service";
import { TipoCertificadoService } from "src/app/core/services/tipo-certificado.service";
import { UanatacaService } from "src/app/core/services/uanataca.service";
import { UsuariosService } from "src/app/core/services/usuarios.service";
import { Certificado } from "src/app/models/Certificado.model";
import { TipoCertificado } from "src/app/models/TipoCertificado.model";
import { FilesService } from "src/app/core/services/files.service";
import { SignatureSizeService } from "src/app/core/services/signature-size.service";
import { UanatacaIdentificadorService } from "src/app/core/services/uanataca-identificador.service";
import { k } from "src/environments/properties";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { HelpToursService } from "src/app/core/tours/help-tours.service";

interface Item {
  id_user?: string;
  usuario: string;
  correo: string;
  estado: string;
}

type PerfilPanelId = "datos" | "certificados" | "password";

type ImageSource =
  | File
  | {
    buffer: ArrayBuffer | Uint8Array;
    mime?: string;
    name?: string;
  };
@Component({
  selector: "app-perfil",
  templateUrl: "./perfil.component.html",
  styleUrls: ["./perfil.component.scss"],
})
export class PerfilComponent implements OnInit, AfterViewInit, OnDestroy {
  public active = 1;
  public userToken: string;
  public formPerfil: FormGroup;
  public tipoGrupo: string;

  public showCurrentPassword: boolean;
  public showNewPassword: boolean;
  public showRepeatNewPassword: boolean;

  public formChangePassword: FormGroup;
  public formCertificate: FormGroup;

  public certificados: Certificado[] = [];
  public tiposCeritificados: TipoCertificado[] = [];
  public identificadores: any = [];

  public userId: string;
  public certificadoId: any;
  public userName: string;

  public certificateFound: boolean = false;
  public allowManualCertificate: boolean;
  gruposUsuario: any[];

  idGroup: string;
  public userArrayExcluir: string[] = [];
  public arrayIdUserGroup: string[] = [];
  public fechaDesdeInput?: HTMLInputElement;
  fullData: Item[] = [];
  currentItems: Item[] = [];
  totalItems: number = 0;

  toast = Swal;

  private certificatesTourShown = false;

  public isLdap = false;

  // SELLO
  selectedFiles: File | File[] | FileList | null = null;
  imagenFirma: string;
  imagenUrl: string;
  scaled: any;
  firmaCustom: boolean = false;
  existeImagen: boolean = false;
  formSignatureSize: FormGroup;
  firmaConImagen: boolean = false;
  formCertificateIsSubmited: boolean;

  /** Control del ngb-accordion (panel abierto) */
  public activePanelId: PerfilPanelId = "datos";

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private certificadoService: CertificadoService,
    private tipoCertificadoService: TipoCertificadoService,
    private uanatacaService: UanatacaService,
    private usuarioService: UsuariosService,
    private uanatacaIdentificadorService: UanatacaIdentificadorService,
    private tours: HelpToursService,
    private signatureSizeService: SignatureSizeService,
    private filesService: FilesService,
  ) {
    this.formPerfil = this.fb.group({
      username: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required]),
      isActive: new FormControl("", [Validators.required]),
      roles: new FormControl("", [Validators.required]),
      firstName: new FormControl("", [Validators.required]),
      lastName: new FormControl("", [Validators.required]),
      createdAt: new FormControl("", [Validators.required]),
      updatedAt: new FormControl("", [Validators.required]),
      accesoGuiado: new FormControl(false),
    });

    this.formPerfil.get("username")?.disable();
    this.formPerfil.get("email")?.disable();

    this.formChangePassword = this.fb.group({
      currentPassword: new FormControl("", [Validators.required]),
      newPassword: new FormControl("", [Validators.required]),
      repeatPassword: new FormControl("", [Validators.required]),
    });

    this.formCertificate = this.fb.group(
      {
        nombre: new FormControl("", [Validators.required]),
        scratchcard: new FormControl("", [Validators.required]),
        usuario_id: new FormControl("", [Validators.required]),
        tipo_certificado_id: new FormControl("", [Validators.required]),
        fecha_vigencia_desde: new FormControl("", [Validators.required]),
        fecha_vigencia_hasta: new FormControl("", [Validators.required]),
        status_certificado_uanataca: [{ value: "", disabled: true }],
        id_uanataca_identificador: [{ value: "", disabled: true }],
      },
      {
        validators: this.fechasVigenciaValidator(),
      },
    );

    this.formSignatureSize = this.fb.group({
      id: new FormControl("", []),
      nombre: new FormControl("", [Validators.required]),
      nombre_corto: new FormControl("", [Validators.required]),
      width: new FormControl("", [Validators.required]),
      height: new FormControl("", [Validators.required]),
    });
  }
  ngOnDestroy(): void {
    this.tours.stop();
  }

  ngAfterViewInit(): void {
    // ✅ Si quieres tour automático del perfil al entrar, déjalo.
    // Si no, comenta esta línea y solo quedará el botón de ayuda.
    this.onHelp(true);
  }

  async onCertificadosOpened() {
    // Evitar repetir el tour
    if (this.certificatesTourShown) return;

    // Solo si NO tiene certificados
    if ((this.certificados?.length ?? 0) > 0) return;

    this.certificatesTourShown = true;

    // Asegurar que no hay otro tour activo
    this.tours.stop();

    // Pequeña espera por render
    await this.sleep(150);

    this.tours.start("first_certificate_hint", false);
  }

  async ngOnInit() {
    this.userToken = localStorage.getItem(k.token);

    if (!this.userToken) return;

    const dataUser = await this.authService.dataUser(this.userToken);

    this.isLdap = dataUser.isLdap;
    this.formPerfil.setValue({
      username: dataUser.username,
      email: dataUser.email,
      isActive: dataUser.isActive,
      roles: dataUser.roles,
      firstName: dataUser.firstName,
      lastName: dataUser.lastName,
      createdAt: dataUser.createdAt,
      updatedAt: dataUser.updatedAt,
      accesoGuiado: dataUser.accesoGuiado ?? false,
    });

    this.userId = dataUser?.id;

    this.userName = dataUser?.username;
    this.tipoGrupo = dataUser?.tipoGrupo;
    this.firmaConImagen = dataUser.firmarConImagen;
    this.validateSello(dataUser);

    this.toastAlert();

    await this.getCertificates();
    await this.getTipoCertificados();
    await this.getUanatacaIdentificadores();

    this.formCertificate.patchValue({
      ...this.formCertificate.value,
      usuario_id: this.userId,
    });

    // ✅ Si el sistema es nuevo y todos deben tener certificado:
    // Si el usuario NO tiene ninguno, lanzamos el hint automáticamente.
  }

  /** Abre un panel del accordion */
  openPanel(id: PerfilPanelId) {
    this.activePanelId = id;
  }

  private sleep(ms: number) {
    return new Promise<void>((resolve) => setTimeout(resolve, ms));
  }

  /** Tour principal del Perfil */
  async onHelp(force = false) {
    this.openPanel("datos");
    await this.sleep(150);
    this.tours.start("profile_help", force);
  }

  // ---------------------------
  // Certificados / modales
  // ---------------------------

  async openModalCertificado(data: any, content: any) {
    this.certificadoId = data.id;
    await this.getGruposUsuarioCeritificado({
      id_certificado: data.id,
      id_usuario: this.userId,
    });
    this.openModal(content);
    this.tours.start("modal_associate_groups_help", false);
  }

  async removeCertificado(id: any) {
    const result = await Swal.fire({
      title: "¿Eliminar certificado?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#d33",
      reverseButtons: true,
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      await lastValueFrom(this.certificadoService.deleteCertificate(id));

      await Swal.fire({
        title: "Eliminado",
        text: "El certificado fue eliminado correctamente.",
        icon: "success",
      });

      this.getCertificates();
    } catch (error) {
      console.error(error);
    }
  }

  openModal(content: any) {
    this.formCertificate.reset();

    this.formCertificate.patchValue({
      usuario_id: this.userId,
    });

    this.formCertificate.get("status_certificado_uanataca")?.disable();
    this.formCertificate.get("id_uanataca_identificador")?.disable();

    this.certificateFound = false;
    this.allowManualCertificate = false;
    this.formCertificateIsSubmited = false;

    this.modalService.open(content, {
      centered: true,
      size: "lg",
    });

    setTimeout(() => {
      this.tours.start("certificate_add_help", false);
    }, 200);
  }

  async groupChange(content: any) {
    this.idGroup = content;
    if (!this.idGroup) {
      this.userArrayExcluir = [];
      this.arrayIdUserGroup = [];
    }
  }

  async asignarUsuarioGrupo() {

    if (!this.userId) {
      this.alert(
        "warning",
        "Usuario requerido",
        "El usuario es requerido para realizar está acción",
      );
      return;
    }
    if (!this.idGroup) {
      this.alert(
        "warning",
        "Grupo requerido",
        "El grupo es requerido para realizar está acción",
      );
      return;
    }
    if (!this.certificadoId) {
      this.alert(
        "warning",
        "Certificado requerido",
        "El certificado es requerido para realizar está acción",
      );
      return;
    }

    await lastValueFrom(
      this.usuarioService.asignUserGroup({
        id_usuario: this.userId,
        id_grupo: this.idGroup,
        id_certificado: this.certificadoId,
      }),
    );

    this.alert("success", "Asignación realizada correctamente");
    this.getGruposUsuarioCeritificado({
      id_certificado: this.certificadoId,
      id_usuario: this.userId,
    });
    this.idGroup = "";
  }

  async getTipoCertificados() {
    const tipoCertificadoList = await lastValueFrom(
      this.tipoCertificadoService.getTipoCertificados(1, 20),
    );
    if (tipoCertificadoList?.body)
      this.tiposCeritificados = tipoCertificadoList.body;
  }

  async getCertificates() {
    const certificadosList = await lastValueFrom(
      this.certificadoService.getCertificados(this.userId),
    );
    if (certificadosList?.body) this.certificados = certificadosList.body;
  }

  async getUanatacaIdentificadores() {
    const identificadoresList = await lastValueFrom(
      this.uanatacaIdentificadorService.getAll(),
    );

    this.identificadores = identificadoresList;
  }

  async removeAsignacionGrupo(id: any) {
    Swal.fire({
      title: "Eliminar asignación!",
      text: "¿Deseas eliminar esta asignación?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await lastValueFrom(this.usuarioService.deleteGrupo(id));
        this.getGruposUsuarioCeritificado({
          id_certificado: this.certificadoId,
          id_usuario: this.userId,
        });
        this.alert("success", "Asignación eliminada correctamente");
      }
    });
  }

  async getGruposUsuarioCeritificado(data: any) {
    const response = await lastValueFrom(
      this.usuarioService.getUserGroupsByCertificate(data),
    );
    if (response?.body) this.gruposUsuario = response.body;
  }

  async searchScratchcard() {
    const scratch = this.formCertificate.value.scratchcard?.toString().trim();

    if (!scratch) {
      this.alert(
        "warning",
        "Scratchcard requerido",
        "Debe ingresar un scratchcard para realizar la búsqueda",
      );
      return;
    }

    const yaExiste = this.certificados.some(
      (x: any) => x.scratchcard === scratch,
    );
    if (yaExiste) {
      this.alert(
        "warning",
        "Certificado ya agregado",
        "Este certificado ya está asociado a este usuario",
      );
      return;
    }

    try {
      const response = await lastValueFrom(
        this.uanatacaService.getRequestScratchcard(scratch),
      );
      
      const fechaFromRaw = response?.body?.valid_from;
      const fechaToRaw = response?.body?.valid_to;
      const name = response?.body?.name;
      const status = response?.body?.status;
      const idIdentificador = response?.body?.count_certicates;

      if (!response?.body?.profile) {
        this.alert(
          "warning",
          "Certificado no encontrado",
          "No existe un usuario asociado a este scratchcard",
        );
        this.certificateFound = false;
        this.allowManualCertificate = false;
        return;
      }

      this.certificateFound = true;
      this.allowManualCertificate = false;

      const profile = response.body.profile;
      const profileFound = this.tiposCeritificados.find(
        (x: any) => x?.perfil.trim() === profile?.trim(),
      );

      if (profileFound) {
        this.formCertificate.patchValue({
          scratchcard: scratch,
          usuario_id: this.userId,
          tipo_certificado_id: profileFound.id,
          fecha_vigencia_desde: this.toDateTimeLocal(fechaFromRaw),
          fecha_vigencia_hasta: this.toDateTimeLocal(fechaToRaw),
          nombre: name,
          status_certificado_uanataca: status,
          id_uanataca_identificador: idIdentificador,
        });
        this.formCertificate.get("status_certificado_uanataca")?.disable();
        this.formCertificate.get("id_uanataca_identificador")?.disable();
      } else {
        this.alert(
          "warning",
          "Tipo de certificado no configurado",
          "El perfil devuelto por Uanataca no tiene un tipo de certificado configurado en el sistema",
        );
      }
    } catch (error: any) {
      const status = error?.status;

      if (status === 404) {
        this.alert(
          "warning",
          "Sin resultados",
          "No existe un usuario asociado a este scratchcard",
        );
        this.certificateFound = false;
        this.allowManualCertificate = false;
      } else if (status === 400) {
        this.alert("error", "Error", `${error.error.message}`);
        this.certificateFound = false;
        this.allowManualCertificate = false;
      } else if (status === 500) {
        Swal.fire({
          title: "Información del certificado no disponible",
          text: "No fue posible completar automáticamente los datos del certificado. Puede agregarlos manualmente, asegurándose de que sean correctos. Si no cuenta con esta información, revise el correo de enrolamiento enviado desde psc.bcr@bcr.gob.sv o contacte a la oficina de firma electrónica para obtener ayuda.",
          icon: "warning",
        });

        this.formCertificate.patchValue({
          status_certificado_uanataca: "",
          id_uanataca_identificador: "",
        });
        this.formCertificate.get("status_certificado_uanataca")?.enable();
        this.formCertificate.get("id_uanataca_identificador")?.enable();

        this.certificateFound = false;
        this.allowManualCertificate = true;

        this.formCertificate.patchValue({
          scratchcard: scratch,
          usuario_id: this.userId,
          tipo_certificado_id: "",
          fecha_vigencia_desde: "",
          fecha_vigencia_hasta: "",
          nombre: "",
        });
      } else {
        this.alert(
          "error",
          "Error al consultar el certificado",
          "Ocurrió un error al consultar el certificado. Intente nuevamente",
        );
        this.certificateFound = false;
        this.allowManualCertificate = false;
      }
    }
  }

  toDateTimeLocal(utc: string): string {
    if (!utc) {
      return "";
    }

    const d = new Date(utc);

    if (isNaN(d.getTime())) {
      console.error("Fecha inválida recibida:", utc);
      return "";
    }

    const pad = (n: number) => n.toString().padStart(2, "0");

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  toDateTimeLocalTable(utc: string): string {
    if (utc === "" || utc === null) return "";
    const d = new Date(utc);
    const pad = (n: number) => n.toString().padStart(2, "0");

    return (
      `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}` +
      ` ${pad(d.getHours())}:${pad(d.getMinutes())}`
    );
  }

  private fechasVigenciaValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const fechaDesde = control.get("fecha_vigencia_desde")?.value;
      const fechaHasta = control.get("fecha_vigencia_hasta")?.value;

      // Si alguna fecha está vacía, dejamos que Validators.required
      // se encargue de esa validación.
      if (!fechaDesde || !fechaHasta) {
        return null;
      }

      const desde = new Date(fechaDesde);
      const hasta = new Date(fechaHasta);

      if (desde > hasta) {
        return {
          fechaVigenciaInvalida: true,
        };
      }

      return null;
    };
  }

  toUTCWithZ(localDateTime: string): string {
    return new Date(localDateTime).toISOString().replace(".000", "");
  }

  async deleteCertificate() {
    await lastValueFrom(
      this.certificadoService.create({ ...this.formCertificate.getRawValue() }),
    );
  }

  async saveCertificate() {
    // Validar la cantidad de certificados
    this.formCertificateIsSubmited = true;

    const cantidadCertificadosBefore = this.certificados.length;

    if (!this.formCertificate.valid) {
      this.certificateFound = false;
      this.formCertificateIsSubmited = false;

      this.alert(
        "warning",
        "Campos requeridos",
        "Debe completar los campos obligatorios"
      );

      return;
    }

    try {
      this.formCertificate.patchValue({
        fecha_vigencia_desde: this.toUTCWithZ(
          this.formCertificate.value.fecha_vigencia_desde
        ),
        fecha_vigencia_hasta: this.toUTCWithZ(
          this.formCertificate.value.fecha_vigencia_hasta
        ),
      });

      await lastValueFrom(
        this.certificadoService.create({
          ...this.formCertificate.getRawValue(),
        })
      );

      this.certificateFound = false;

      this.alert(
        "success",
        "Certificado registrado",
        "El certificado fue registrado correctamente"
      );

      await this.getCertificates();

      this.formCertificate.reset();
      this.modalService.dismissAll();

      const cantidadCertificadosAfter = this.certificados.length;

      if (
        cantidadCertificadosBefore === 0 &&
        cantidadCertificadosAfter > 0
      ) {
        // Después de agregar el PRIMER certificado
        // mostrar el mensaje de la guía interactiva
        this.tours.start("first_add_certificate", false);
      }

    } catch (error: any) {

      this.formCertificate.reset();
      this.certificateFound = false;
      this.formCertificateIsSubmited = false;


    }
  }

  async save() {
    if (this.formPerfil.valid) {
      const { isActive, roles, createdAt, updatedAt, ...rest } =
        this.formPerfil.value;
      const response = await lastValueFrom(
        this.usuarioService.updateUsuario(this.userId, {
          ...rest,
          updated_at: updatedAt,
        }),
      );
      this.alert(
        "success",
        "Datos actualizados correctamente",
        response.message,
      );
    } else {
      this.alert(
        "warning",
        "Campos requeridos",
        "Debe completar los campos obligatorios",
      );
    }
  }

  async onAccesoGuiadoChange(): Promise<void> {
    const control = this.formPerfil.get("accesoGuiado");

    if (!control) {
      return;
    }

    const nuevoValor = control.value;
    const valorAnterior = !nuevoValor;

    const mensaje = nuevoValor
      ? "¿Deseas activar la guía interactiva?"
      : "¿Deseas desactivar la guía interactiva?";

    const texto = nuevoValor
      ? "Las guías interactivas se mostrarán cuando estén disponibles."
      : "Las guías interactivas dejarán de mostrarse automáticamente.";

    const result = await Swal.fire({
      title: "Guía interactiva",
      text: mensaje,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    });

    if (!result.isConfirmed) {
      // Restauramos el valor anterior
      control.setValue(valorAnterior, { emitEvent: false });
      return;
    }

    try {
      await lastValueFrom(
        this.usuarioService.updateUsuario(this.userId, {
          accesoGuiado: nuevoValor,
        }),
      );

      this.tours.setTourEnabled(nuevoValor);

      this.alert(
        "success",
        nuevoValor
          ? "Guía interactiva activada"
          : "Guía interactiva desactivada",
        texto,
      );

      // Opcional pero recomendable:
      // actualizamos también el valor guardado localmente
      localStorage.setItem("accesoGuiado", String(nuevoValor));
    } catch (error) {
      console.error("Error actualizando accesoGuiado:", error);

      // Si falló el endpoint, regresamos el switch
      control.setValue(valorAnterior, { emitEvent: false });

      this.alert(
        "error",
        "No se pudo actualizar la configuración",
        "Ocurrió un error al actualizar la guía interactiva.",
      );
    }
  }

  //SELLO DIGITALL

  validateSello(user: any) {
    this.firmaCustom = false;

    if (user.urlImagenFirma) {
      this.imagenFirma = user.urlImagenFirma;
      this.existeImagen = true;
      this.showImageFirma();
    } else {
      this.existeImagen = false;
      this.imagenFirma = user.username + "-imagen-firma.png";
      this.imagenUrl = "assets/images/not_image.jpg";
    }
  }

  async handleFiles(files: any) {
    this.selectedFiles = files;

    const file: File[] =
      this.selectedFiles instanceof File
        ? [this.selectedFiles]
        : Array.isArray(this.selectedFiles)
          ? this.selectedFiles
          : this.selectedFiles // FileList
            ? Array.from(this.selectedFiles as FileList)
            : [];
    if (file.length > 0) {
      this.existeImagen = true;
      const info: any = await this.loadImageInfo(file[0]);
      this.imagenUrl = info.dataUrl;
    }
  }

  getScaleByImageWidth(width: number): number {
    if (width >= 2600) return 0.15;
    if (width >= 2200) return 0.2;
    if (width >= 1900) return 0.25;
    if (width >= 1600) return 0.3;
    if (width >= 1400) return 0.4;
    if (width >= 1200) return 0.5;
    if (width >= 1000) return 0.6;
    if (width >= 800) return 0.7;
    if (width >= 600) return 0.8;

    return 1;
  }

  getImageSizeCategory(width: number): string {
    if (width >= 2200) return "extraLarge";
    if (width >= 1400) return "large";
    if (width >= 800) return "medium";
    if (width >= 400) return "small";

    return "tiny";
  }

  calculateScaledSize(width: number, height: number) {
    const scale = this.getScaleByImageWidth(width).toFixed(2);

    return {
      scale,
      width: Math.round(width * Number(scale)),
      height: Math.round(height * Number(scale)),
    };
  }

  /*ESTA FUNCION QUEDA ASI PARA PODER DETECTAR EL COMPONENTE
    Y PODER LIMPIAR EL UPLOAD QUE SE REDERIZA EN EL MODAL*/
  async subirImagen(fileUpload: FileUploadComponent) {
    const files: File[] =
      this.selectedFiles instanceof File
        ? [this.selectedFiles]
        : Array.isArray(this.selectedFiles)
          ? this.selectedFiles
          : this.selectedFiles // FileList
            ? Array.from(this.selectedFiles as FileList)
            : [];

    if (files.length === 0) {
      this.alert("warning", "Debe seleccionar o arrastrar una imagen");
      return;
    }

    const formData = new FormData();
    files.forEach((f) => formData.append("file", f, f.name));

    if (this.firmaCustom) {
      if (this.formSignatureSize.valid) {
        await this.saveImage(formData);
        await this.saveSignatureSize();
      }
    } else {
      await this.saveImage(formData);
    }

    await this.showImageFirma();
    this.alert("success", "Imagen cargada correctamente");
    fileUpload.clearFiles();
  }

  async saveImage(formData) {
    await lastValueFrom(
      this.usuarioService.subidaImagen(this.userId, formData),
    );
  }

  async saveSignatureSize() {
    const { id, ...payload } = this.formSignatureSize.value;
    await lastValueFrom(this.signatureSizeService.create(payload, true));
  }

  async showImageFirma() {
    let params = new HttpParams().set("disk", "local");

    const result = await lastValueFrom(
      this.filesService.verImagenFirma(this.imagenFirma, params),
    );
    // result.body.data podría ser un array de números o un ArrayBuffer
    const rawBuffer = result.body.data;

    const u8 =
      rawBuffer instanceof Uint8Array ? rawBuffer : new Uint8Array(rawBuffer);

    // 👉 Usa la MISMA función para sacar ancho/alto desde buffer
    try {
      const info: any = await this.loadImageInfo({
        buffer: u8,
        mime: "image/png", // si sabes el tipo, mejor
        name: "firma-backend",
      });

      // Si quieres usar su propio dataUrl:
      this.imagenUrl = info.dataUrl;
    } catch (error) {
      console.error("Error en loadImageInfo (buffer): ", error);
    }
  }

  onFirmaCustomChange() {
    let msg = "";
    let alert = "";

    if (this.firmaConImagen) {
      msg = "¿Deseas activar la firma predeterminada con imagen?";
      alert = "La firma predeterminada con imagen sea activo con éxito";
    } else {
      msg = "¿Deseas desactivar la firma predeterminada con imagen?";
      alert = "La firma predeterminada con imagen sea desactivado con éxito";
    }

    Swal.fire({
      title: "Firma con imagen!",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await lastValueFrom(
          this.usuarioService.firmarConImagen(this.userId, {
            firmarConImagen: this.firmaConImagen,
          }),
        );
        this.alert("success", alert);
      } else {
        if (this.firmaConImagen) {
          this.firmaConImagen = false;
        } else {
          this.firmaConImagen = true;
        }
      }
    });
  }

  getDisplayMime(mime: string) {
    if (!mime) return "";
    return mime.split("/");
  }

  private guessMimeFromBuffer(u8: Uint8Array): string {
    if (u8[0] === 0x89 && u8[1] === 0x50) return "image/png";
    if (u8[0] === 0xff && u8[1] === 0xd8) return "image/jpeg";
    if (u8[0] === 0x47 && u8[1] === 0x49) return "image/gif";
    return "application/octet-stream";
  }

  loadImageInfo(source: ImageSource) {
    return new Promise((resolve, reject) => {
      let mime = "application/octet-stream";
      let name: string | undefined;
      let size: number | undefined;

      // --------- CASO 1: File ---------
      if (source instanceof File) {
        const file = source;

        mime = file.type || "application/octet-stream";
        name = file.name;
        size = file.size;

        const reader = new FileReader();

        reader.onload = (e: any) => {
          const dataUrl = e.target.result as string;
          const img = new Image();

          img.onload = () => {
            const width = img.width;
            const height = img.height;

            // tu cálculo de escala
            this.scaled = this.calculateScaledSize(width, height);
            this.formSignatureSize.patchValue({
              nombre_corto: this.getImageSizeCategory(this.scaled.width),
              width: this.scaled.width,
              height: this.scaled.height,
            });
            resolve({
              width,
              height,
              mime,
              name,
              size,
              dataUrl: dataUrl,
            });
          };

          img.onerror = (err) => reject(err);
          img.src = dataUrl;
        };

        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(file);

        return;
      }

      // --------- CASO 2: Buffer ---------
      let u8: Uint8Array;

      if (source.buffer instanceof Uint8Array) {
        u8 = source.buffer as Uint8Array;
      } else {
        u8 = new Uint8Array(source.buffer as ArrayBuffer);
      }

      mime = source.mime || this.guessMimeFromBuffer(u8);
      name = source.name;
      size = u8.byteLength;

      // Usamos el buffer interno como BlobPart para evitar el error de tipos
      const blob = new Blob([u8.buffer as ArrayBuffer], { type: mime });
      const objectUrl = URL.createObjectURL(blob);

      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;

        // si también quieres escalar cuando viene de buffer:
        this.scaled = this.calculateScaledSize(width, height);
        this.formSignatureSize.patchValue({
          nombre_corto: this.getImageSizeCategory(this.scaled.width),
          width: this.scaled.width,
          height: this.scaled.height,
        });

        const reader = new FileReader();
        reader.onload = (e: any) => {
          const dataUrl = e.target.result as string;

          resolve({
            width,
            height,
            mime,
            name,
            size,
            dataUrl,
          });

          URL.revokeObjectURL(objectUrl);
        };

        reader.readAsDataURL(blob);
      };

      img.onerror = (err) => {
        URL.revokeObjectURL(objectUrl);
        reject(err);
      };

      img.src = objectUrl;
    });
  }

  getStyleString(scaleData: { width: number; height: number }) {
    return `
    width: ${scaleData.width}px;
    height: ${scaleData.height}px;
    border: 2px solid #2196F3;
    border-radius: 6px;
    display: inline-block;
  `;
  }

  getStyleContenedorImg(scaleData: { width: number; height: number }) {
    return `
    width: ${scaleData.width}px;
    height: ${scaleData.height}px;
    text-align: center;
    margin-bottom: 2%;
  `;
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({ icon: icontext, title, text });
  }
}
